import { Component, OnInit } from '@angular/core';
import { SsoAuthService } from 'src/app/ecan/sso-auth.service';
import { AppConfigurationService } from 'src/app/stp/stp-app/common';

@Component({
  selector: 'app-email-required',
  templateUrl: './email-required.component.html'
})
export class EmailRequiredComponent implements OnInit {

  constructor(private ssoAuthService: SsoAuthService,
    private appConfig: AppConfigurationService) { }

  ngOnInit() {
  }

  public logout() {
    this.ssoAuthService.logout(this.appConfig.getValue('webUrl') + '/login');
  }
}
